<template>
  <!-- Pagination -->
  <div class="pagination p12" v-if="totalPages > 1">
    <ul>
      <li :class="{'disabled': !canDecrease}" @click.prevent="onPreviousClick">Précédent</li>
      
      <li v-for="n in pagesList" :key="n" :class="computeClass(n)" @click="onClick(n)">
        {{n}}
      </li>
      
      <li :class="{'disabled': !canIncrease}" @click.prevent="onNextClick">Suivant</li>
    </ul>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        startPage: null,
        endPage: null
      }
    },

    // currentPage: index of current page in `paginatedList` (0 based index)
    // totalPages: max number of pages
    // eachSide: max number of links shown on each side
    props: {
      'currentPage': Number,
      'totalPages': Number,
      'eachSide': {
        type: Number,
        default: 2,
        validator: value => value >= 0
      }
    },

    computed: {
      pagesList () {
        const pages = []

        this.computeLoopEdges()
        if (this.startPage > 1)
          pages.push(1)
        if (this.startPage > 2)
          pages.push("...")

        _.range(this.startPage, this.endPage).map(n => pages.push(n))

        if (this.endPage < this.totalPages - 1)
          pages.push("...")
        if (this.endPage < this.totalPages)
          pages.push(this.totalPages)

        return pages
      },

      canDecrease() {
        return this.currentPage > 0
      },

      canIncrease() {
        return this.currentPage < this.totalPages - 1
      }
    },

    methods: {
      isLink (n) {
          return Number.isInteger(n)
      },

      computeClass (n) {
        return (this.isLink(n)) ?
          { 'is-active': (n - 1) === this.currentPage } :
          { 'is-nan': true }
      },

      onPreviousClick() {
        if (this.canDecrease) {
          this.$emit('click', this.currentPage - 1)
        }
      },

      onClick (n) {
        if (this.isLink(n))
          this.$emit('click', n - 1)
      },

      onNextClick() {
        if (this.canIncrease) {
          this.$emit('click', this.currentPage + 1)
        }
      },

      computeLoopEdges () {
        if (this.totalPages <= (2 * this.eachSide) + 5) {
          // too few pages, so display them all
          this.startPage = 1
          this.endPage = this.totalPages + 1
        } else if (this.currentPage <= this.eachSide + 3) {
          // currentPage is too close to the beginning
          this.startPage = 1
          this.endPage = (2 * this.eachSide) + 3
        } else if (this.currentPage >= this.totalPages - (this.eachSide + 2)) {
          // currentPage is too close to the end
          this.startPage = this.totalPages - (2 * this.eachSide) - 2
          this.endPage = this.totalPages + 1
        } else {
          // regular case
          this.startPage = this.currentPage - this.eachSide
          this.endPage = this.currentPage + this.eachSide
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pagination{
    padding: 0;
    float: right;

    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;

      li {
        display: inline-block;
        padding: 5px 18px;
        color: #222;
        cursor: pointer;
        user-select: none;
      }
    }

    &.p12 {
      li.disabled {
        background-color: #ccc !important;
        cursor: not-allowed !important;
      }

      li:first-of-type, li:last-of-type, .is-active {
        background-color: #fb557a;
        color: #fff;
        border-radius: 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/Pagination.vue